import React, { useState } from 'react';
import { InfoCardStack as IInfoCardStack } from '../types/cards.types';
import InfoCardStack from './InfoCardStack';

interface Props {
  stacks: IInfoCardStack[];
}

const InfoCardStackList = ({ stacks }: Props) => {
  const [openStackId, setOpenStackId] = useState<string | null>(null);

  const handleToggle = (stackId: string) => {
    setOpenStackId(openStackId === stackId ? null : stackId);
  };

  return (
    <div className="space-y-4 pb-3 text-start">
      {stacks.map((stack, index) => (
        <InfoCardStack
          key={stack.id}
          stack={stack}
          iconIndex={index}
          isExpanded={openStackId === stack.id}
          onToggle={handleToggle}
        />
      ))}
    </div>
  );
};

export default InfoCardStackList;
